import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryAuth } from "../../reduxStore/helper";

export const driverBehaviorApi = createApi({
  reducerPath: "driverBehaviorApi",
  name: "driverBehaviorApi",
  refetchOnMountOrArgChange: true,
  baseQuery: baseQueryAuth(process.env.REACT_APP_CORE_API_URL),
  tagTypes: ["Areas", "Vendors", "EcoDriveReports"],
  endpoints: (builder) => ({
    getDriverScores: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.page !== undefined) queryParams.append("page", params.page);
        if (params?.per_page) queryParams.append("per_page", params.per_page);
        if (params?.start_date) queryParams.append("start_date", params.start_date);
        if (params?.end_date) queryParams.append("end_date", params.end_date);
        if (params?.area) queryParams.append("area", params.area);
        if (params?.group) queryParams.append("group", params.group);

        return {
          url: `/driver_scores${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
          method: "GET",
        };
      },
    }),
    getAreas: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.page !== undefined) queryParams.append("page", params.page);
        if (params?.per_page) queryParams.append("per_page", params.per_page);
        if (params?.q) queryParams.append("q", params.q);

        return {
          url: `/areas${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
          method: "GET",
        };
      },
      providesTags: ["Areas"],
    }),
    createArea: builder.mutation({
      query: ({ formData }) => ({
        url: "/areas",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Areas"],
    }),
    updateArea: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/areas/${id}`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["Areas"],
    }),
    deleteArea: builder.mutation({
      query: ({ id }) => ({
        url: `/areas/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Areas"],
    }),
    getArea: builder.query({
      query: ({ id }) => ({
        url: `/areas/${id}`,
        method: "GET",
      }),
      providesTags: ["Areas"],
    }),
    getVendors: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.page !== undefined) queryParams.append("page", params.page);
        if (params?.per_page) queryParams.append("per_page", params.per_page);

        return {
          url: `/vendors${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
          method: "GET",
        };
      },
      providesTags: ["Vendors"],
    }),
    getEcoDriveReports: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.start_dt) queryParams.append("start_dt", params.start_dt);
        if (params?.end_dt) queryParams.append("end_dt", params.end_dt);
        if (params?.area_id) queryParams.append("area_id", params.area_id);
        if (params?.page !== undefined) queryParams.append("page", params.page);
        if (params?.per_page) queryParams.append("per_page", params.per_page);

        return {
          url: `/eco_drive_reports${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
          method: "GET",
        };
      },
      providesTags: ["EcoDriveReports"],
    }),
  }),
});

export const {
  useGetDriverScoresQuery,
  useGetAreasQuery,
  useGetAreaQuery,
  useCreateAreaMutation,
  useUpdateAreaMutation,
  useDeleteAreaMutation,
  useGetVendorsQuery,
  useGetEcoDriveReportsQuery,
} = driverBehaviorApi;
